/* eslint-disable react-hooks/exhaustive-deps */
import { useRef } from "react";
import {
  empty,
} from "../../Utilities/utils";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "../staff/Staff.css";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import { FaPrint, FaUser } from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import colors from "../../config/colors";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import Header4 from "../../components/headers/Header4";
import StaticFormLabel from "../../components/form/StaticFormLabel";

const printReport = () => {
  window.print();
};

const studentFormFields = [
    "First Name",
    "Last Name",
    "Middle Name",
    "Gender",
    "Address",
    "Entry Class",
    "Previous School",
    "State of Residence",
    "L.G.A of Residence",
    "State of Origin",
    "LGA of Origin",
    "Nationality",
    "Email",
    "Phone Number",
    "Religion",
    "Date of Birth",
]

const StudentForm = ({ ...props }) => {
  const printRef = useRef();
  const { user } = useContext(AuthContext);

  return (
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Student Form" />
          <div className="report-sheet-contents-display">
            <ButtonIcon
                buttonText="Print"
                icon={<FaPrint />}
                marginTop={3}
                iconMarginRight={8}
                backgroundColor="transparent"
                color={colors.primary}
                borderColor={colors.primary}
                height={30}
                width={150}
                onClick={() => printReport()}
            />
            <div className="transcript-container-script broad-sheet mt-20">
                <div
                className="transcript-display-script"
                ref={printRef}
                >
                    <div className="report-header">
                        <div style={{ width: 100, height: 100 }}>
                        <img
                            src={
                            !empty(user) && !empty(user.avatar)
                                ? user.avatar
                                : ""
                            }
                            alt="non"
                            style={{ width: "100%", height: "100%" }}
                        />
                        </div>
                        <div>
                        <div className="report-title">
                            {!empty(user) && !empty(user.name) ? user.name : "NA"}
                        </div>
                        <div className="report-subtitle">
                            { user?.address || "--"}
                        </div>
                        <div className="report-subtitle fs-14">
                            {`TEL.: ${
                                user?.phoneNumber1 + " ," || ""
                            }${
                                user?.phoneNumber2 + " ," || ""
                            }${ user?.ownerPhone || "" }`}
                        </div>
                        <div className="report-subtitle fs-14 mb-10">
                            {`Email: ${ user.email || "---" }`}
                        </div>
                        </div>
                        <div className="student-profile" style={{ width: 100, height: 100 }}>
                            <div className="avatar-box">
                                <FaUser />
                            </div>
                        </div>
                    </div>

                    <div className="form-body mt-20">
                        <Header4 className="bold fs-18 mb-10">Student Form Content</Header4>
                        {
                            studentFormFields?.map((field, idx) => (
                                <StaticFormLabel key={idx} title={field} />
                            ))
                        }
                    </div>
                    <div className="flex flex-end">
                        &copy;{ new Date().getFullYear() }
                    </div>
                </div>
            </div>
          </div>
        </main>
      </AppWrapper>
  );
};

export default StudentForm;
